import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { getUrlParamValue } from 'utils';

import { IFrame } from '../IFrame';
import { LoadingOverlay } from '../LoadingOverlay';
import { useStateContext } from '../../context';
import { StoreCard } from '../StoreCard';

interface IProps {
    className?: string;
    onClickBack(): void;
}

interface IParams {
    [key: string]: string;
}

const BaseReflexAppointment: React.FC<IProps> = ({
    className,
    onClickBack,
}) => {
    const context = useStateContext();
    const { selectedStore } = context;
    const [iFrameLoaded, setIFrameLoaded] = useState(false);
    const iFrameRef = useRef<HTMLIFrameElement>(null);
    const {
        t,
        i18n: { language },
    } = useTranslation();

    useEffect(() => {
        if (!iFrameRef.current) return;

        const iFrameEl = iFrameRef.current;

        iFrameEl.addEventListener('load', () => {
            setIFrameLoaded(true);
        });

        return () => {
            iFrameEl.removeEventListener('load', () => {
                setIFrameLoaded(true);
            });
        };
    }, [iFrameRef]);

    if (!selectedStore) return null;

    const invitationId = getUrlParamValue('invitation_id') ?? '';

    const params: IParams = {
        'spx.StartPageIndex': '2',
        fsversion: `${process.env.REACT_APP_REFLEX_VERSION}`,
        adv: 'BvdW',
        'ftr.6.CommentsFilter.DefaultValue': '',
        'ftr.6.TextFilter.Visible': 'true',
        'ftr.7.FacilityFilter.Visible': 'false',
        'ftr.8.FacilityFilter.Visible': 'false',
        'ftr.8.FacilityFilter.Reference': `F${selectedStore.id}`,
        'ftr.9.ActivityFilter.Visible': 'false',
        'ftr.9.ActivityFilter.DefaultValue': `${process.env.REACT_APP_REFLEX_APPOINTMENT_ID}`,
        'ftr.19.CommentsFilter.Visible': 'false',
        'ftr.19.CommentsFilter.DefaultValue': 'BvhW_aanvraag',
        'ftr.22.ExtraInfoFieldsFilter.DefaultValue': `${invitationId}`,
    };

    const queryString = Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&');

    const reflexLocale = language === 'fr' ? 'fr-fr' : 'nl-nl';

    const reflexUrl = `${process.env.REACT_APP_REFLEX_FORM_BASE_URL}/pbe/${reflexLocale}/Start?${queryString}`;

    return (
        <div className={className}>
            {iFrameLoaded && (
                <StoreCard
                    appointment
                    hideDistance
                    store={selectedStore}
                    onClick={onClickBack}
                />
            )}
            <IFrame ref={iFrameRef} src={reflexUrl} />
            {!iFrameLoaded && (
                <LoadingOverlay>{t('appointment.loadingTimes')}</LoadingOverlay>
            )}
        </div>
    );
};

export const ReflexAppointment = styled(BaseReflexAppointment)`
    margin-top: 15px;
    position: relative;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    .controlscontainer .simpleavailabilityfilter > .label:first-child {
        display: none;
    }
`;
